export const DRAG_PREVIEW_WIDTH = 240;
export const DRAG_PREVIEW_HEIGHT = 180;
